const toUSString = (valueString) =>
  valueString.toLocaleString("en-us", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  });

export default toUSString;
